import type { AlertBannerCardProps } from '../../../types/alerts.d';
import { faClock } from '@fortawesome/pro-light-svg-icons';
import React from 'react';
import { IconWithText } from '../IconWithText/IconWithText';
import { formatDate } from '../../components/DateComponent';
import { formatDateTime } from '../../components/Time';


const EN_DASH = '–';


export const DateComponent = ({
	date,
}: {
	date: AlertBannerCardProps['date']
}): React.JSX.Element => {
	let dateText = '';
	if (date.isExpired) {
		dateText = `${formatDate(date.published)} ${EN_DASH} ${formatDate(date.expireStringOrUndef)}`;
	} else {
		dateText = date.isModified
			? `Sist oppdatert: ${formatDateTime(date.modified)}`
			: `Publisert: ${formatDateTime(date.published)}`;
	}
	return (
		<IconWithText icon={faClock} text={dateText}/>
	);
};
